<div class="step1-basic">
  <h3 class="step-title">
    <i class="pi pi-info-circle"></i>
    Información Básica y Configuración Temporal
  </h3>
  
  <form [formGroup]="form" class="step-form">
    <!-- Información Básica -->
    <div class="form-section">
      <h4 class="section-title">Información General</h4>
      
      <div class="form-grid">
        <div class="form-field">
          <label for="name">Nombre de la Estrategia <span class="required">*</span></label>
          <input 
            id="name"
            type="text" 
            pInputText 
            formControlName="name"
            placeholder="Ej: Recordatorio 7 días antes del vencimiento"
            class="w-full"
          />
          <small *ngIf="form.get('name')?.invalid && form.get('name')?.touched" class="p-error">
            El nombre es requerido (máx. 200 caracteres)
          </small>
        </div>
  
        <div class="form-field">
          <label for="masterTemplateId">Plantilla Maestra <span class="required">*</span></label>
          <p-dropdown
            inputId="masterTemplateId"
            formControlName="masterTemplateId"
            [options]="templates"
            optionLabel="name"
            optionValue="_id"
            placeholder="Selecciona una plantilla maestra"
            [filter]="true"
            filterBy="name"
            [style]="{'width': '100%'}"
          ></p-dropdown>
          <small *ngIf="form.get('masterTemplateId')?.invalid && form.get('masterTemplateId')?.touched" class="p-error">
            Debe seleccionar una plantilla maestra
          </small>
          <small class="help-text">
            <i class="pi pi-info-circle"></i>
            La plantilla maestra contiene los contenidos para todos los canales
          </small>
        </div>
      </div>
      
      <div class="form-field mt-3">
        <label for="description">Descripción</label>
        <textarea 
          id="description"
          pInputTextarea 
          formControlName="description"
          placeholder="Describe el propósito de esta estrategia..."
          rows="3"
          class="w-full"
        ></textarea>
        <small class="help-text">Opcional. Máximo 500 caracteres</small>
      </div>
    </div>
    
    <!-- Configuración Temporal -->
    <div class="form-section">
      <h4 class="section-title">Configuración Temporal</h4>
      
      <!-- Escenario + Input inline para PRE_DUE_DATE -->
      <div class="scenario-row">
        <div class="form-field scenario-field">
          <label for="scenario">Escenario <span class="required">*</span></label>
          <p-dropdown
            inputId="scenario"
            formControlName="scenario"
            [options]="scenarioOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecciona un escenario"
            [style]="{'width': '100%'}"
          ></p-dropdown>
          <small class="help-text">
            <i class="pi pi-info-circle"></i>
            Define cuándo se ejecutará la estrategia en relación al vencimiento
          </small>
        </div>
        
        <!-- Input de días para PRE_DUE_DATE (inline) -->
        <ng-container formGroupName="daysRange">
          <div class="form-field days-field" *ngIf="isPreDueDateScenario">
            <label for="preDueDays">Días antes <span class="required">*</span></label>
            <p-inputNumber
              inputId="preDueDays"
              formControlName="minDays"
              [showButtons]="true"
              buttonLayout="horizontal"
              decrementButtonIcon="pi pi-minus"
              incrementButtonIcon="pi pi-plus"
              [step]="1"
              [min]="1"
              [max]="90"
              placeholder="15"
              [style]="{'width': '100%'}"
              suffix=" días"
            ></p-inputNumber>
            <small class="help-text">
              <i class="pi pi-info-circle"></i>
              Se enviará únicamente este día antes del vencimiento
            </small>
          </div>
        </ng-container>
      </div>
      
      <!-- Rango de Días solo para POST_DUE_DATE (Cobranza) -->
      <div class="form-grid days-range-grid" *ngIf="isPostDueDateScenario" formGroupName="daysRange">
        <div class="form-field">
          <label for="postMinDays">{{ daysRangeLabels.minLabel }} <span class="required">*</span></label>
          <p-inputNumber
            inputId="postMinDays"
            formControlName="minDays"
            [showButtons]="true"
            buttonLayout="horizontal"
            decrementButtonIcon="pi pi-minus"
            incrementButtonIcon="pi pi-plus"
            [step]="1"
            [min]="0"
            [max]="365"
            placeholder="0"
            [style]="{'width': '100%'}"
            suffix=" días"
          ></p-inputNumber>
        </div>
        
        <div class="form-field">
          <label for="postMaxDays">{{ daysRangeLabels.maxLabel }}</label>
          <p-inputNumber
            inputId="postMaxDays"
            formControlName="maxDays"
            [showButtons]="true"
            buttonLayout="horizontal"
            decrementButtonIcon="pi pi-minus"
            incrementButtonIcon="pi pi-plus"
            [step]="1"
            [min]="0"
            [max]="365"
            [allowEmpty]="true"
            placeholder="Sin límite"
            [style]="{'width': '100%'}"
            suffix=" días"
          ></p-inputNumber>
          <small class="help-text">
            <i class="pi pi-info-circle"></i>
            Debe ser mayor que "Desde". Vacío = sin límite.
          </small>
        </div>
      </div>
      
      <!-- Preview Box -->
      <div class="preview-box">
        <i class="pi pi-calendar"></i>
        <div class="preview-content">
          <strong>Vista previa de ejecución:</strong>
          <span>{{ previewDate }}</span>
        </div>
      </div>
    </div>

    <!-- Opciones de Ejecución (movidas desde step3) -->
    <div class="form-section">
      <h4 class="section-title">Opciones de Ejecución</h4>
      
      <div class="switches-row">
        <div class="switch-item">
          <p-inputSwitch formControlName="autoExecute" inputId="autoExecute"></p-inputSwitch>
          <label for="autoExecute">
            <span class="switch-label">Ejecución Automática</span>
            <small class="switch-description">Si está activo, la estrategia se ejecutará automáticamente según este programada</small>
          </label>
        </div>
        
        <div class="switch-item">
          <p-inputSwitch formControlName="active" inputId="active"></p-inputSwitch>
          <label for="active">
            <span class="switch-label">Estrategia Activa</span>
            <small class="switch-description">Si está desactivada, la estrategia no se procesará aunque esté programada</small>
          </label>
        </div>
      </div>
    </div>
  </form>
</div>
